document.querySelectorAll('.js-video').forEach(video => {
    const loadVideo = () => {
        const videoid = video.dataset.videoid;
        video.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoid + '?wmode=opaque&autoplay=1&enablejsapi=1&modestbranding=1&rel=0&showinfo=0" frameBorder="0" allowFullScreen class="w-100"></iframe>'
        video.removeEventListener('click', loadVideo);
    }

    video.addEventListener('click', loadVideo);
});